import { render, staticRenderFns } from "./TermReports.vue?vue&type=template&id=1dfcaace&scoped=true"
import script from "./TermReports.vue?vue&type=script&lang=js"
export * from "./TermReports.vue?vue&type=script&lang=js"
import style0 from "./TermReports.vue?vue&type=style&index=0&id=1dfcaace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfcaace",
  null
  
)

export default component.exports